import { Field, FormikProvider, useFormik, } from 'formik';
import React, { useEffect, useState } from 'react';
import { Col, InputGroup, Row, Form, Button } from 'react-bootstrap';
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import Sweetalert from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import Swal from 'sweetalert2';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonPageHeading } from '../../../CommonUtilities/CommonHeading/CommonPageHeading';
import { CONTEXT_HEADING } from '../../../CommonUtilities/Validations/RegularExpAndVar';

const CandidateDetailsBack = () => {

    function getData() {
        let villUrl = config.url.DSC_URL + "candidate-study-details";
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data?.candidatereg_status === true) {
                const data = response?.data?.candidatereg?.[0];
                if (data) {
                    Formik.setFieldValue('aadhaarNo', data?.aadhaar_no || '');
                    Formik.setFieldValue('certificateSubCaste', data?.caste || '');
                    Formik.setFieldValue('casteApplicantID', data?.candidate_id || '');
                    Formik.setFieldValue('casteApplicantName', data?.applicant_name || '');
                    Formik.setFieldValue('casteDetails', data?.caste || '');
                    Formik.setFieldValue('dob', data?.dob || '');
                    Formik.setFieldValue('email', data?.email || '');
                    Formik.setFieldValue('mobileNo', data?.mobile_no || '');
                    Formik.setFieldValue('gender', data?.gender || '');
                }
            }
        })
    }
    useEffect(() => { getData() }, [])

    const initialValues = {
        meesevaNo: '',
        aadhaarNo: '',
        certificateSubCaste: '',
        casteApplicantID: "",
        casteApplicantName: '',
        casteDetails: '',
        dob: '',
        email: '',
        mobileNo: '',
        gender: '',
        otp: ''
    };
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        onSubmit: () => {
            sendOtp()
        },
    })
    const handleSubmit = () => {
        let values = Formik?.values;
        if (!values?.otp) {
            return Sweetalert('Please Enter OTP', 'error')
        }
        let url = config.url.DSC_URL + "candidate-cnf-back"
        CommonAxiosPost(url, values).then((res) => {
            if (res?.data?.status === true) {
                Swal.fire({
                    title: 'Success',
                    text: 'Successfully returned to edit the application.Please Login again to continue',
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = '/'; // Redirect to login page
                    }
                });
            }
            else {
                Sweetalert(res?.data?.sdesc ? res?.data?.sdesc : 'Unauthorized Access ! Please Login', "error")
            }
        })
        Formik?.resetForm(); // Reset form after submission
    };
    const [showOtp, setShowOtp] = useState(false)
    const [showOtpBtn, setOtpBtn] = useState(true);
    const [resendOtp, setResendOtp] = useState(false);

    function sendOtp() {

        Swal.fire({
            title: 'Are you sure you want to go back to edit the application?',
            html: `OTP will be Send to your Mobile No. ${Formik?.values?.mobileNo}`, icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Send OTP",
        }).then((res) => {
            if (res.isConfirmed) {
                let otpUrl = config.url.DSC_URL + "generate-edit-otp"
                CommonAxiosPost(otpUrl).then((rres) => {
                    if (rres?.data?.status === true) {
                        setShowOtp(true)
                        setOtpBtn(false)
                        setTimer(180);
                    }
                    else if (rres?.data?.scode === '03') {
                        Sweetalert(rres?.data?.sdesc, "warning")

                    } else {
                        Sweetalert('Internal Server Issue', "warning")
                    }

                })
            }
        })
    }
    const [timer, setTimer] = useState(180); // Timer in seconds
    useEffect(() => {
        let interval = null;
        if (!showOtpBtn) {
            interval = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer > 0) {
                        if (prevTimer < 122) {
                            setResendOtp(true);
                            return prevTimer - 1;
                        } else if (prevTimer > 1) {
                            return prevTimer - 1;
                        }
                        else {
                            clearInterval(interval);
                            setResendOtp(true); // Enable resend button when timer reaches 0
                            return 0;
                        }
                    }
                });
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [showOtpBtn]);

    const formatTime = (timeInSeconds) => {
        if (isNaN(timeInSeconds) || timeInSeconds < 0) {
            return "0:00";
        }
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = timeInSeconds % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };
    const resendOTP = () => {
        Formik.setFieldValue("otp", "")
        sendOtp()

    };
    return (
        <FormikProvider value={Formik}>
            <CommonPageHeading heading='GO Back to Edit Application' />
            <Form className="form-section" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange} >
                <div className="personal-head">
                    <span>Candidate Details</span>
                </div>
                <div className="personal-row personal-roweducation">
                    <Row className="pt-2">
                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3">
                            <InputGroup>
                                <label className="input-lable mb-2">Aadhar Number</label>
                                <Field readOnly className="form-control w-100" name="aadhaarNo" />
                            </InputGroup>
                        </Col>

                    </Row>
                    <Row className="pb-3">
                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3">
                            <InputGroup>
                                <label className="input-lable mb-2">Applicant ID</label>
                                <Field readOnly className="form-control w-100" name="casteApplicantID" />
                            </InputGroup>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3">
                            <InputGroup>
                                <label className="input-lable mb-2">Applicant Name</label>
                                <Field readOnly className="form-control w-100" name="casteApplicantName" />
                            </InputGroup>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3">
                            <InputGroup>
                                <label className="input-lable mb-2">Caste</label>
                                <Field readOnly className="form-control w-100" name="casteDetails" />
                            </InputGroup>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3">
                            <InputGroup>
                                <label className="input-lable mb-2">Date of Birth</label>
                                <Field readOnly className="form-control w-100" name="dob" />
                            </InputGroup>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3">
                            <InputGroup>
                                <label className="input-lable mb-2">Gender</label>
                                <Field readOnly className="form-control w-100" name="gender" />
                            </InputGroup>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3">
                            <InputGroup>
                                <label className="input-lable mb-2">Email</label>
                                <Field readOnly className="form-control w-100" name="email" />
                            </InputGroup>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3">
                            <InputGroup>
                                <label className="input-lable mb-2">Mobile No</label>
                                <Field readOnly className="form-control w-100" name="mobileNo" />
                            </InputGroup>
                        </Col>
                    </Row>

                </div>
                <Row className='px-3'>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='mt-2'>

                        <h6><span style={{ fontFamily: 'bold' }} className='text-danger'>NOTE : </span>
                            <span className='text-sm'>
                                If you have already made a payment for this application to any {CONTEXT_HEADING === "TET" ? "papers" : "posts"}, you will be able to apply again using the same amount.
                            </span>
                        </h6>


                    </Col>
                </Row>
                <Row className='pb-4'>
                    {showOtp === true &&
                        <React.Fragment>

                            <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3} className='pt-2 mt-4'>
                                {resendOtp === true ? <React.Fragment>
                                    <Form.Label className="input-lable mt-2">Didn't receive code? </Form.Label>&emsp;
                                    <Button variant="primary" type="button" className="" onClick={() => { resendOTP() }}>Resend OTP </Button>
                                </React.Fragment>
                                    : ''}
                            </Col>
                            <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-4'>
                                <React.Fragment>
                                    <p>
                                        Time Remaining:  {formatTime(timer)}
                                    </p>
                                </React.Fragment>
                            </Col>
                            <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3} className='pt-2 mt-4'>
                                <Form.Group controlId="otp">
                                    <Field
                                        type="text"
                                        name="otp"
                                        className="input-field form-control"
                                        placeholder="Enter OTP"
                                        maxLength={6}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3} className='pt-2 mt-4'>
                                <div className='float-end'>
                                    <Button variant="success" type="button" className="submit-btn btn-success" onClick={() => { handleSubmit() }}>
                                        Go Back To Edit
                                    </Button>
                                </div>
                            </Col>
                        </React.Fragment>}
                    {showOtp === false && <React.Fragment>
                        <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}></Col>
                        <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2} className='pt-2 mt-2'>
                            <div className='float-end'><Button variant="primary" type="submit" className="submit-btn btn-primary"> Generate OTP </Button></div>
                        </Col>
                    </React.Fragment>}
                </Row>
            </Form>
        </FormikProvider>
    );
};

export default CandidateDetailsBack;
